import Button from "components/common/Button/Button";
import { Title } from "components/common/Formatting";
import apiData from "lib/stores/apiData";
import styles from "./index.module.scss";
import classNames from "classnames";
import { useSnapshot } from "valtio";

const GlobalSummaryContent = () => {
  const { globals, metadata, worldwide } = useSnapshot(apiData);

  return (
    <div className={classNames(styles["global-summary-content-container"])}>
      {/* <Title className={classNames(styles["summary-title"], "uppercase")} element="h1" variant="lg"> */}
      {/*   Globally */}
      {/* </Title> */}
      <div className={classNames(styles["prevalence-statement-wrapper"])}>
        <h3 className={classNames(styles["population-label"])}>
          {worldwide.global_population.slice(0, 4)}
          <span>m</span>
        </h3>
        <p className={styles["global-prevalence-statement"]}>{metadata.labels["overview-description"]}</p>
      </div>
      <button
        type="button"
        className={classNames(styles["prevalence-button"], styles["summary-content-button-root-styles"], styles["is-variant-explore"])}
        onClick={() => {
          window.location.hash = "mode=data";
          window.history.pushState(null, null, window.location.href);
        }}
      >
        Explore Global Data
      </button>
    </div>
  );
};

export default GlobalSummaryContent;
